<script lang="ts">
	import { yyyy, zzzz } from "../store.svelte";
	import { toast } from "../lib/toast.svelte.ts";

	import Fa from "svelte-fa";
	import {
		faInfo,
		faPencil,
		faCalculator,
		faCamera,
		faBookmark,
		faBookBookmark,
		faPersonDigging,
		faClipboardList,
		faScaleBalanced,
		faDrawPolygon,
		faCodeBranch,
	} from "@fortawesome/free-solid-svg-icons";

	let { expanded = $bindable(), control = $bindable() } = $props();

	let display = (item: string) => {
		yyyy.ctrl.control = item;
		console.log("Displaying ", item);
	};

	console.log("here");
</script>

<div class="menu-container">
	<button
		class="menu-button"
		onclick={() => {
			display("NetworkInfo");
		}}
	>
		<span class="button-icon">
			<Fa icon={faInfo} size="1x" />
		</span>
		<span class="button-text">Network Info</span>
	</button>


	<button
		class="menu-button"
		onclick={() => {
			display("OutageCalculator");
		}}
	>
		<span class="button-icon">
			<Fa icon={faCalculator} size="1x" />
		</span>
		<span class="button-text">Outage Calculator</span>
	</button>

	<button
		class="menu-button"
		onclick={() => {
			display("EnergyBalance");
		}}
	>
		<span class="button-icon">
			<Fa icon={faScaleBalanced} size="1x" />
		</span>
		<span class="button-text">Energy Balance</span>
	</button>

	{#if yyyy.features?.triageAnnotations}
	<button
		class="menu-button"
		onclick={() => {
			display("TriageApplet");
		}}
	>
		<span class="button-icon">
			<Fa icon={faClipboardList} size="1x" />
		</span>
		<span class="button-text">Triage Annotations</span>
	</button>
	{/if}

	<button
		class="menu-button"
		onclick={() => {
			display("Spotlight");
		}}
	>
		<span class="button-icon">
			<Fa icon={faDrawPolygon} size="1x" />
		</span>
		<span class="button-text">Spotlight</span>
	</button>

	<button
		class="menu-button"
		onclick={() => {
			display("Chronicle");
		}}
	>
		<span class="button-icon">
			<Fa icon={faCodeBranch} size="1x" />
		</span>
		<span class="button-text">Chronicle</span>
	</button>

	<button
		class="menu-button"
		onclick={() => {
			// Check if location is available for new annotations
			if (!yyyy.pos || !yyyy.pos.info) {
				toast.error("Turn on the location first");
				zzzz.emit("pulse-location-button");
				return;
			}

			// Quick check for location permission
			display("NewAnnotation");
		}}
	>
		<span class="button-icon">
			<Fa icon={faCamera} size="1x" />
		</span>
		<span class="button-text">Arbitrary Annotator</span>
	</button>

</div>

<style>
	.menu-container {
		display: flex;
		flex-direction: column;
		gap: 0.5rem;
		width: 100%;
	}

	.menu-button {
		display: flex;
		align-items: center;
		padding: 0.5rem;
		border: 1px solid #3273dc;
		background-color: #3273dc;
		color: white;
		border-radius: 4px;
		font-size: 0.9rem;
		cursor: pointer;
		transition: background-color 0.2s;
	}

	.menu-button:hover {
		background-color: #2366d1;
	}

	.button-icon {
		display: flex;
		align-items: center;
		justify-content: center;
		margin-right: 0.5rem;
		width: 1.5rem;
	}

	.button-text {
		flex: 1;
	}

</style>

